'use client';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import YouTubePlayerModal from '@/components/YouTubePlayerModal';

interface Project {
  title: string;
  category: string;
  description: string;
  tags: string[];
  color: string;
  image: string;
  link?: string;
  popular?: boolean;
  isDemo?: boolean;
  youtubeId?: string;
}

const projects: Project[] = [
{
  title: 'متجر كتب إلكتروني',
  category: 'تصميم ويب',
  description: 'تصميم وتطوير متجر متكامل لبيع الكتب والمؤلفات',
  tags: ['تصميم ويب'],
  color: 'from-green-900/60',
  image: "/assets/images/836103c7e78039ff4acc32c83cb1819f-df80e12f-a37e-4bb6-ac04-93e35fdaeab5_1786361145039_55b1d809-1786361155917.webp",
  link: 'https://forestgreen-louse-771290.hostingersite.com/',
  popular: false
},
{
  title: 'سوبرماركت إلكتروني متكامل',
  category: 'تصميم ويب',
  description: 'منظومة تجارة رقمية شاملة للسلع والمنتجات مع دعم سلة التسوق المتطورة',
  tags: ['تصميم ويب'],
  color: 'from-teal-900/60',
  image: "/assets/images/lnYes7ZyDfKvjzqprYEiU_1786361439355_14ee040f-1786361494436.webp",
  link: 'https://teal-panther-681369.hostingersite.com/',
  popular: false
},
{
  title: 'موقع صالون تجميل وعناية فاخر',
  category: 'تصميم ويب',
  description: 'تصميم موقع عصري لعرض خدمات التجميل واستعراض باقات الأسعار مع نظام حجز',
  tags: ['تصميم ويب', 'الأكثر طلباً'],
  color: 'from-yellow-900/60',
  image: "/assets/images/image-1786361552844.png",
  link: 'https://greenyellow-woodpecker-builder-5bx6kbjchtap9on9.hostingersite.com/',
  popular: true
},
{
  title: 'موقع إلكتروني لصالون حلاقة + سهل التعديل',
  category: 'تصميم ويب',
  description: 'موقع أنيق لصالون حلاقة يجذب العملاء الراقيين ويعكس الاحترافية والفخامة.',
  tags: ['تصميم ويب'],
  color: 'from-amber-900/60',
  image: '/assets/images/image-1786361803604.png',
  link: 'https://monetizxbarbershopexample2.carrd.co/',
  popular: false
},
{
  title: 'موقع حلاقة فاخر - نموذج 1',
  category: 'تصميم ويب',
  description: 'موقع احترافي عالي التحويل لصالون حلاقة فاخر يعزز الأرباح ويجذب العملاء المميزين.',
  tags: ['تصميم ويب'],
  color: 'from-blue-900/60',
  image: '/assets/images/image-1786363378530.png',
  link: 'https://monetizxbarbershopexampleboltfast1.bolt.host/',
  popular: false
},
{
  title: 'موقع حلاقة فاخر - نموذج 2',
  category: 'تصميم ويب',
  description: 'تصميم متميز لصالون حلاقة راقٍ يرفع معدلات التحويل ويضاعف الأرباح.',
  tags: ['تصميم ويب'],
  color: 'from-purple-900/60',
  image: '/assets/images/image-1786363415716.png',
  link: 'https://premmonetzx1.vercel.app/',
  popular: false
},
{
  title: 'موقع حلاقة فاخر - نموذج 3',
  category: 'تصميم ويب',
  description: 'نموذج متكامل لموقع صالون حلاقة فاخر يستقطب العملاء ويحقق أعلى معدلات الربح.',
  tags: ['تصميم ويب'],
  color: 'from-rose-900/60',
  image: '/assets/images/image-1786363479012.png',
  link: 'https://iraqi-barber-hub.lovable.app/',
  popular: false
},
{
  title: 'منصة الاستثمار العقاري عالي العائد',
  category: 'تصميم ويب',
  description: 'منصة عقارية تجمع بين سهولة تصفح الخيارات المتاحة وعرض أعلى الفرص الاستثمارية عائدًا، مصممة خصيصاً لجذب المهتمين ومضاعفة عملائك.',
  tags: ['تصميم ويب'],
  color: 'from-emerald-900/60',
  image: '/assets/images/image-1786379563671.png',
  link: 'https://realstatemonetizx1.vercel.app/'
},
{
  title: 'إعلان فيديو يوتيوب',
  category: 'التسويق الرقمي',
  description: 'فيديو تسويقي رقمي يُعرض داخل الموقع مع التحكم بالسرعة وشريط التقدم دون الانتقال إلى يوتيوب.',
  tags: ['التسويق الرقمي', 'فيديو'],
  color: 'from-red-900/60',
  image: 'https://i.ytimg.com/vi/ghXjcPT96w0/hqdefault.jpg',
  youtubeId: 'ghXjcPT96w0',
  popular: false
},
{
  title: 'إعلان عطر فاخر - نموذج 1',
  category: 'التسويق الرقمي',
  description: 'تصميم إعلاني احترافي لعطر فاخر يستهدف الجمهور الراقي ويعزز الهوية البصرية للعلامة التجارية.',
  tags: ['التسويق الرقمي'],
  color: 'from-violet-900/60',
  image: '/assets/images/watermarked_openart-grok-imagine-1_1786271096552_c7e95de2-1786473210763.png',
  popular: false
},
{
  title: 'إعلان عطر فاخر - نموذج 2',
  category: 'التسويق الرقمي',
  description: 'محتوى إعلاني مبتكر لمنتج عطور يجذب الانتباه ويحفز قرار الشراء لدى العملاء المستهدفين.',
  tags: ['التسويق الرقمي'],
  color: 'from-pink-900/60',
  image: '/assets/images/watermarked_openart-image_1786271024960_9e8b4e41_1786271024986_c6232b72-1786473210823.png',
  popular: false
},
{
  title: 'إعلان عطر فاخر - نموذج 3',
  category: 'التسويق الرقمي',
  description: 'تصميم إبداعي لحملة تسويقية رقمية لعطر فاخر يرفع معدلات التفاعل والمبيعات.',
  tags: ['التسويق الرقمي'],
  color: 'from-indigo-900/60',
  image: '/assets/images/watermarked_YdO4MNiN7edJvDQFr58hZJlRtjPqSnRFIeWOAyGKuUmTsBU4X1DEkigjglENoZIOQT7Ci6xFJkGVGmiYpmOq0PrQnwmQH5a1xP9DA4bjwRM_wqb2vBBtjrxm-ppz3e2Iv_tIqtXGn-30zI9h9lJrGc8Qd7RLJmzvf-UajPbG3j_uqmRHXqjA4KPo1wD6juu--1786473210763.jpg',
  popular: false
},
{
  title: 'إعلان عطر فاخر - نموذج 4',
  category: 'التسويق الرقمي',
  description: 'إعلان رقمي متميز لعطر فاخر يعكس الأناقة والفخامة ويستقطب شريحة العملاء المميزين.',
  tags: ['التسويق الرقمي'],
  color: 'from-fuchsia-900/60',
  image: '/assets/images/watermarked_yFCli-xiR-PlEBwdz9KJ5eI7algngNV4oqF41PZjKPGOvPP-iuFr_LqUkOsHy9nPT_hxAoSnHS1Q2FSQP2qjz9reCpFwk8UtGr3t_GiMW6Iw_IgI6B0vfhhLrrvLcxp152c5Wn1vUXQCLG1hPh26t9fCDCuTKUUahQ_X8pURjt1Qbf_K8DVqb0qEDNgQ4eWg-1786473210670.jpg',
  popular: false
},
{
  title: 'إعلان عطر فاخر - نموذج 5',
  category: 'التسويق الرقمي',
  description: 'تصميم إعلاني فاخر لمنتج عطور يضاعف الوعي بالعلامة التجارية ويحقق أعلى معدلات التحويل.',
  tags: ['التسويق الرقمي'],
  color: 'from-cyan-900/60',
  image: '/assets/images/watermarked_zNcLOVTdUzL_oDqyxrEocGq1gzwDC-7XxzSQAsICXtlQwOOZUsNysrxc2CQeU3sivwnRFauZgypcWrQCdyAriliSpzM7NGbXE-o4LHxsDXTTbfL_trmItocFUD4_M28SLHNzwbXLZGuwDfFCKt3YKiqqowpw0TQHghXqN53OSExUIuqHoD3JYYJwTMrKpyPG-1786473210757.jpg',
  popular: false
},
{
  title: 'إعلان Solvané للعطور',
  category: 'التسويق الرقمي',
  description: 'تصميم إعلاني راقٍ لعطر Solvané يجسّد الفخامة والأناقة ويستهدف الجمهور الراقي.',
  tags: ['التسويق الرقمي'],
  color: 'from-amber-900/60',
  image: '/assets/images/watermarked_ChatGPT_Image_Aug_11__2026__08_19_36_PM-1786473274355.png',
  popular: false
},
{
  title: 'إعلان Noiré للطبيعة',
  category: 'التسويق الرقمي',
  description: 'إعلان إبداعي لعلامة Noiré يبرز جمال الطبيعة ويعزز الهوية البصرية للعلامة التجارية.',
  tags: ['التسويق الرقمي'],
  color: 'from-green-900/60',
  image: '/assets/images/watermarked_dae-1786473274311.png',
  popular: false
},
{
  title: 'إعلان Noir Élégance',
  category: 'التسويق الرقمي',
  description: 'تصميم إعلاني فاخر لعطر Noir Élégance يعكس الغموض والأناقة الراقية.',
  tags: ['التسويق الرقمي'],
  color: 'from-slate-900/60',
  image: '/assets/images/watermarked_DyfPPUtn2F8zUIwODVTiTvmb6KxcSfjiSZWy8lVqpELbTvRfgVjhwMxnlWw7z0hW4CItpw7wbLMlMjl0VMynxZpiqWCbckRM6sy-eOgxfHxOm8BtZ2ZIZDaipsZheryNLm9rKgRHYo_JlAhQtknsbBUz3OLMrpnTeJs-jVvThx2KMOrx9TnQWtoqvMxMlv7N-1786473273646.jpg',
  popular: false
},
{
  title: 'إعلان Nextgen Smartwatch',
  category: 'التسويق الرقمي',
  description: 'إعلان تقني متطور لساعة Nextgen الذكية يستهدف محبي التكنولوجيا والأسلوب العصري.',
  tags: ['التسويق الرقمي'],
  color: 'from-blue-900/60',
  image: '/assets/images/watermarked_openart-gpt-image-2-edit-1_1786471990176_b147eea0-1786473274187.png',
  popular: false
},
{
  title: 'إعلان ساعة Aetos',
  category: 'التسويق الرقمي',
  description: 'تصميم إعلاني فاخر لساعة Aetos يجمع بين الدقة والأناقة لاستقطاب العملاء المميزين.',
  tags: ['التسويق الرقمي'],
  color: 'from-rose-900/60',
  image: '/assets/images/watermarked_openart-gpt-image-2-edit-1_1786472008358_79bac276__1_-1786473274243.png',
  popular: false
},
{
  title: 'إعلان Aeterna - سيارة عربي',
  category: 'التسويق الرقمي',
  description: 'إعلان احترافي بالعربية لسيارة Aeterna يجمع بين الفخامة والهوية البصرية القوية.',
  tags: ['التسويق الرقمي'],
  color: 'from-orange-900/60',
  image: '/assets/images/watermarked_35db3750-3c5c-4d2c-b2b3-2e72ef102907-1786474143932.png',
  popular: false
},
{
  title: 'إعلان Noiré - منظر طبيعي',
  category: 'التسويق الرقمي',
  description: 'تصميم إعلاني بانورامي لعلامة Noiré يستحضر جمال الطبيعة ويعزز الحضور البصري للعلامة.',
  tags: ['التسويق الرقمي'],
  color: 'from-teal-900/60',
  image: '/assets/images/watermarked_915a8537-3320-4c6f-86f2-337de3751a8b-1786474143474.png',
  popular: false
},
{
  title: 'إعلان Aeterna - دبي',
  category: 'التسويق الرقمي',
  description: 'إعلان سيارة Aeterna بخلفية أفق دبي الساحر يعكس الفخامة والطموح في السوق الخليجي.',
  tags: ['التسويق الرقمي'],
  color: 'from-sky-900/60',
  image: '/assets/images/watermarked_a1fe39ba-7845-46ff-aed1-d63646569b92-1786474143938.png',
  popular: false
},
{
  title: 'إعلان Solvané للعطور - عربي',
  category: 'التسويق الرقمي',
  description: 'إعلان عربي راقٍ لعطر Solvané يجسّد الأناقة الشرقية ويستهدف الجمهور العربي المميز.',
  tags: ['التسويق الرقمي'],
  color: 'from-yellow-900/60',
  image: '/assets/images/watermarked_ChatGPT_Image_Aug_11__2026__08_19_27_PM-1786474143996.png',
  popular: false
},
{
  title: 'إعلان Premier Coast العقاري',
  category: 'التسويق الرقمي',
  description: 'حملة تسويقية رقمية لمشروع Premier Coast العقاري تبرز الفرص الاستثمارية الساحلية الفاخرة.',
  tags: ['التسويق الرقمي'],
  color: 'from-emerald-900/60',
  image: '/assets/images/watermarked_3e76305e-5fc0-4d58-a1b4-c7920fc3ad8f-1786474144099.png',
  popular: false
},
{
  title: 'إعلان Velocity للهواتف',
  category: 'التسويق الرقمي',
  description: 'إعلان احترافي لهاتف Velocity يبرز التصميم العصري والأداء المتطور لاستقطاب محبي التكنولوجيا.',
  tags: ['التسويق الرقمي'],
  color: 'from-purple-900/60',
  image: '/assets/images/watermarked_2cb8a4ed-a962-4d51-a95c-0f8decee07de-1786474355745.png',
  popular: false
},
{
  title: 'ضاعف مبيعاتك ببوت عقاري',
  category: 'أتمتة',
  description: 'دع بوت الذكاء الاصطناعي يجيب عن أسئلة عملائك العقارية فوراً، لتركز أنت على إغلاق الصفقات.',
  tags: ['أتمتة'],
  color: 'from-amber-900/60',
  image: '/assets/images/openart-gpt-image-2-1_1786480340214_ef02f998-1786480364523.png',
  isDemo: true,
  popular: false
},
{
  title: 'مساعد المبيعات الذكي لمتجرك',
  category: 'أتمتة',
  description: 'امنح متجرك مساعد مبيعات ذكياً يعمل 24/7، يرشد عملائك للمنتجات المناسبة ويضاعف مبيعاتك تلقائياً.',
  tags: ['أتمتة'],
  color: 'from-amber-900/60',
  image: '/assets/images/openart-gpt-image-2-1_1786480613547_f055578b-1786482011574.png',
  isDemo: true,
  popular: false
}];

const categories = ['الكل', 'تصميم ويب', 'التسويق الرقمي', 'أتمتة'];

const INITIAL_VISIBLE = 6;

interface LightboxState {
  open: boolean;
  image: string;
  title: string;
  zoomed: boolean;
}

export default function PortfolioSection() {
  const [activeCategory, setActiveCategory] = useState('الكل');
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);
  const [lightbox, setLightbox] = useState<LightboxState>({ open: false, image: '', title: '', zoomed: false });
  const [videoPlayer, setVideoPlayer] = useState<{ videoId: string; title: string } | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  const filteredProjects = activeCategory === 'الكل' ?
  projects :
  projects.filter((p) => p.category === activeCategory);

  const visibleProjects = filteredProjects.slice(0, visibleCount);
  const hasMore = filteredProjects.length > visibleCount;

  const openLightbox = useCallback((project: Project) => {
    setLightbox({ open: true, image: project.image, title: project.title, zoomed: false });
  }, []);

  const closeLightbox = useCallback(() => {
    setLightbox({ open: false, image: '', title: '', zoomed: false });
  }, []);

  const toggleZoom = useCallback(() => {
    setLightbox((prev) => ({ ...prev, zoomed: !prev.zoomed }));
  }, []);

  // Close on Escape key
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeLightbox();
    };
    if (lightbox.open) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [lightbox.open, closeLightbox]);

  useEffect(() => {
    setVisibleCount(INITIAL_VISIBLE);
  }, [activeCategory]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [visibleProjects]);

  return (
    <section
      id="portfolio"
      ref={sectionRef}
      className="relative py-24 overflow-hidden"
      style={{ background: '#080808' }}>
      
      <div className="absolute inset-0 grid-pattern opacity-20"></div>
      <div className="orb orb-gold w-80 h-80 top-1/2 right-0 opacity-10"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 delay-100 text-4xl md:text-5xl font-black text-white mb-4">
            نماذج <span className="gradient-text">استعراضية</span>
          </h2>
          <p className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 delay-200 text-gray-400 text-lg max-w-2xl mx-auto">
            نماذج استعراضية مبتكرة تعكس جودة خدماتنا وتصنع الفارق لعلامتك التجارية. استكشف حلولنا اليوم لتجذب المزيد من العملاء وتضاعف حجم مبيعاتك في السوق.
          </p>
        </div>

        {/* Filter tabs */}
        <div className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 delay-300 flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((cat) =>
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
            activeCategory === cat ?
            'bg-amber-600 text-black font-bold shadow-lg shadow-amber-600/30' :
            'bg-amber-900/10 text-gray-400 hover:text-amber-400 hover:bg-amber-900/20 border border-amber-900/20'}`
            }>
            {cat}
          </button>
          )}
        </div>

        {/* Projects grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {visibleProjects.map((project, index) => {
const isDigitalMarketing = project.category === 'التسويق الرقمي';
const isAutomation = project.category === 'أتمتة';
const isVideo = Boolean(project.youtubeId);
            return (
              <div
                key={`${project.title}-${index}`}
                onClick={
                  isVideo
                    ? () => setVideoPlayer({ videoId: project.youtubeId as string, title: project.title })
                    : isDigitalMarketing
                      ? () => openLightbox(project)
                      : undefined
                }
                className={`animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 group rounded-2xl overflow-hidden border border-amber-900/20 hover:border-amber-500/40 transition-all relative ${isVideo ? 'cursor-pointer' : isDigitalMarketing ? 'cursor-zoom-in' : isAutomation ? 'cursor-default' : 'cursor-pointer'}`}
                style={{ transitionDelay: `${index * 100}ms`, background: '#0f0f0f' }}>

                {/* Popular ribbon */}
                {project.popular &&
                  <div className="absolute top-0 left-0 z-20">
                    <div className="bg-amber-500 text-black text-xs font-black px-3 py-1.5 rounded-br-xl flex items-center gap-1">
                      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                      الأكثر طلباً
                    </div>
                  </div>
                }

                {/* Image / Preview */}
                <div className="relative h-48 overflow-hidden bg-gray-900 flex items-center justify-center">
                  {project.image ?
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      onError={(e) => {
                        (e.target as HTMLImageElement).style.display = 'none';
                      }} /> :
                    null}
                  <div className={`absolute inset-0 bg-gradient-to-t ${project.color} opacity-60`}></div>

                  {/* Website preview overlay — only for non-digital-marketing and non-automation */}
                  {!isDigitalMarketing && !isAutomation && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="text-center">
                        <div className="w-12 h-12 rounded-full bg-amber-500/20 border border-amber-500/40 flex items-center justify-center mx-auto mb-2">
                          <svg className="w-6 h-6 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                          </svg>
                        </div>
                        <span className="text-white text-xs font-medium opacity-80">موقع إلكتروني</span>
                      </div>
                    </div>
                  )}

                  {/* Digital marketing click hint */}
                  {isDigitalMarketing && !isVideo && (
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="bg-black/60 backdrop-blur-sm rounded-xl px-4 py-2 flex items-center gap-2">
                        <svg className="w-5 h-5 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                        </svg>
                        <span className="text-white text-sm font-medium">اضغط للعرض</span>
                      </div>
                    </div>
                  )}

                  {isVideo && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-amber-500/90 text-black flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-black/50">
                        <svg className="w-7 h-7 ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7L8 5z" />
                        </svg>
                      </div>
                    </div>
                  )}

                  <div className="absolute top-3 right-3 flex flex-col gap-1.5 items-end">
                    <span className="px-3 py-1 rounded-full bg-black/60 backdrop-blur-sm text-amber-300 text-xs font-medium border border-amber-500/20">
                      {project.category}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-5">
                  <h3 className="text-white font-bold text-lg mb-2 group-hover:text-amber-400 transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">
                    {project.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.tags.map((tag, ti) =>
                      <span
                        key={ti}
                        className="px-2.5 py-1 rounded-lg text-xs font-medium border bg-amber-900/20 text-amber-400 border-amber-900/30">
                        {tag}
                      </span>
                    )}
                  </div>
                  {/* Show link button only for non-digital-marketing and non-automation */}
                  {!isDigitalMarketing && !isAutomation && project.link &&
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 text-sm font-medium transition-colors group/link">
                      <span>عرض الموقع</span>
                      <svg className="w-4 h-4 group-hover/link:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  }
                  {project.youtubeId &&
                    <span className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 text-sm font-medium transition-colors">
                      <span>تشغيل الفيديو</span>
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7L8 5z" />
                      </svg>
                    </span>
                  }
                  {project.isDemo &&
                    <a
                      href={project.title === 'مساعد المبيعات الذكي لمتجرك' ? '/shopping-bot' : '/real-estate-bot'}
                      onClick={(e) => { e.stopPropagation(); }}
                      className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 text-sm font-medium transition-colors group/link">
                      <span>اختبره</span>
                      <svg className="w-4 h-4 group-hover/link:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  }
                </div>
              </div>
            );
          })}
        </div>

        {/* Show More button */}
        {hasMore && (
          <div className="text-center mt-8">
            <button
              onClick={() => setVisibleCount((prev) => prev + 6)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-amber-500/40 text-amber-400 hover:bg-amber-900/20 hover:border-amber-400/60 transition-all duration-200 font-medium text-sm">
              <span>عرض المزيد ({Math.min(filteredProjects.length - visibleCount, 6)}+)</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
        )}

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#contact"
            onClick={(e) => {e.preventDefault();document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });}}
            className="btn-primary inline-flex items-center gap-2 px-8 py-4 rounded-2xl font-bold text-lg">
            ابدأ مشروعك معنا
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </a>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightbox.open && createPortal(
        <div className="fixed inset-0 z-[100]">
          <button
            type="button"
            className="absolute inset-0 bg-black/90 backdrop-blur-sm cursor-pointer"
            aria-label="إغلاق"
            onClick={closeLightbox}
          />

          <div className="relative z-[101] pointer-events-none flex min-h-full items-center justify-center px-5 py-16 sm:p-10 lg:p-16">
          <div
            className="pointer-events-auto relative max-w-5xl max-h-[75dvh]"
          >
            <button
              type="button"
              onClick={closeLightbox}
              className="absolute z-[110] -top-3 -right-3 sm:-top-4 sm:-right-4 w-12 h-12 sm:w-11 sm:h-11 rounded-full bg-amber-500 text-black shadow-[0_8px_24px_rgba(0,0,0,0.45)] flex items-center justify-center hover:bg-amber-400 active:scale-95 transition-all"
              aria-label="إغلاق">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img
              src={lightbox.image}
              alt={lightbox.title}
              onDoubleClick={toggleZoom}
              className={`rounded-xl shadow-2xl shadow-black/80 transition-all duration-300 select-none ${
                lightbox.zoomed
                  ? 'scale-150 cursor-zoom-out max-w-none max-h-none' :'max-w-full max-h-[75dvh] object-contain cursor-zoom-in'
              }`}
              style={lightbox.zoomed ? { maxWidth: '150%', maxHeight: '150vh' } : {}}
              draggable={false}
            />
          </div>
          </div>
        </div>,
        document.body
      )}

      {videoPlayer && (
        <YouTubePlayerModal
          videoId={videoPlayer.videoId}
          title={videoPlayer.title}
          onClose={() => setVideoPlayer(null)}
        />
      )}
    </section>
  );
}
